package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface AccountDeveloperEnvironment : Environment {
    val host: String
    val vizioApiSubscriptionKey: String
    val messageTokenAESKeyMasked: String?
}

@JsExport
abstract class BaseAccountDeveloperEnvironment() : AccountDeveloperEnvironment

@JsExport
data class DevAccountDeveloperEnvironment(
    override val vizioApiSubscriptionKey: String,
    override val host: String = "apim-vizio-ecommerce-dev.vizio.com",
    override val messageTokenAESKeyMasked: String?
) : BaseAccountDeveloperEnvironment()

@JsExport
data class StageAccountDeveloperEnvironment(
    override val vizioApiSubscriptionKey: String,
    override val host: String = "apim-vizio-ecommerce-qa.vizio.com",
    override val messageTokenAESKeyMasked: String?
) : BaseAccountDeveloperEnvironment()


fun chooseAccountDeveloperEnvironment(eCommerceEnvConfig: ECommerceEnvironmentConfig): AccountDeveloperEnvironment {
    return when (eCommerceEnvConfig.environmentGroup) {
        EnvironmentGroup.STAGE -> StageAccountDeveloperEnvironment(vizioApiSubscriptionKey = eCommerceEnvConfig.apiKey, messageTokenAESKeyMasked = eCommerceEnvConfig.messageTokenAESKeyMasked)
        EnvironmentGroup.DEV -> DevAccountDeveloperEnvironment(vizioApiSubscriptionKey = eCommerceEnvConfig.apiKey, messageTokenAESKeyMasked = eCommerceEnvConfig.messageTokenAESKeyMasked)
        EnvironmentGroup.TEST -> TODO("Test Environment for AccountDevApi not defined!")
        EnvironmentGroup.PROD -> TODO("Prod Environment for AccountDevApi not defined!")
        EnvironmentGroup.PREPROD -> TODO("PreProd Environment for AccountDevApi not defined!")
    }
}
